<template>
    <div
        class="ppv2-flex ppv2-items-center ppv2-gap-1.5 ppv2-px-3 ppv2-py-1 ppv2-rounded-full"
        style="background-color: rgba(168, 85, 247, 0.12); border: 1px solid rgba(168, 85, 247, 0.28)"
    >
        <span class="live-dot"></span>
        <span class="poppinsBold ppv2-uppercase" style="color: #a855f7; font-size: 0.6rem; letter-spacing: 0.12em">
            <slot>{{ $t('widgetIntegration.live') }}</slot>
        </span>
    </div>
</template>
<script>
export default {
    name: 'LiveBadge',
}
</script>

<style scoped>
.live-dot {
    width: 6px;
    height: 6px;
    background-color: #a855f7;
    border-radius: 50%;
    display: inline-block;
    box-shadow: 0 0 8px #a855f7;
}
</style>
